import React, { useMemo } from 'react';
import { useLocation } from '@reach/router';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import StepsContainer from './StepsContainer';
import { isRequestedFrom, useLang } from 'utils/localisation';
import { arabicRegion, euroMoneyRegion, ukRegion } from 'define/locale';

import * as styles from './DesktopCalculator.module.scss';

function DesktopCalculator({ containerId = 'calculator', className, title, subtitle, sections }) {
  const location = useLocation();
  const lang = useLang();
  const showCalculation = Boolean(
    typeof window !== 'undefined' && location.pathname === '/contact-us'
      ? isRequestedFrom([...arabicRegion, ...euroMoneyRegion, ...ukRegion, 'us'])
      : false,
  );
  const analyticsEvent = useMemo(() => {
    if (showCalculation) {
      if (lang === 'de') {
        return 'calculator-dach';
      }
      if (isRequestedFrom(ukRegion)) {
        return 'calculator-gb';
      }
      if (isRequestedFrom(arabicRegion)) {
        return 'calculator-mena';
      }
      if (isRequestedFrom(euroMoneyRegion)) {
        return 'calculator-eu';
      }
      if (isRequestedFrom('us')) {
        return 'calculator-us';
      }
    }

    return null;
  }, [showCalculation, lang]);

  return (
    <>
      <Container id={containerId} className={className}>
        <div className={styles.wrapper}>
          <Title>{title}</Title>
          <StepsContainer subtitle={subtitle} sections={sections} analyticsEvent={analyticsEvent} />
        </div>
      </Container>
    </>
  );
}

export default DesktopCalculator;
